import VisibilityToggledSource from '../VisibilityToggledSource';
import { PolygonLayers } from './PolygonLayers';
import { PointLayer } from './PointLayer';
import { ExternalFeatureLayerProps } from './ExternalFeatureLayer.types';
import { LineLayer } from './LineLayer';

const REFRESH_INTERVAL_SECONDS = 3600 * 3; // 3 hours

export const ExternalFeatureLayer = (
  props: ExternalFeatureLayerProps,
): JSX.Element | null => {
  const { visible, sourceId, featureLayer } = props;

  return (
    <VisibilityToggledSource
      visible={visible}
      url={featureLayer.maptilesUrl}
      refreshIntervalSeconds={REFRESH_INTERVAL_SECONDS}
      id={sourceId}
    >
      {featureLayer.geomType === 'point' && <PointLayer {...props} />}
      {featureLayer.geomType === 'polygon' && <PolygonLayers {...props} />}
      {featureLayer.geomType === 'line' && <LineLayer {...props} />}
    </VisibilityToggledSource>
  );
};
